// Move the header logo after the primary navigation for correct reading sequence
$('.header__logo').insertAfter('.header__primary-nav');

// Hide all <br> tags from screen readers for better accessibility
$('br').attr('aria-hidden', 'true');

// Remove tabindex from featured-collections-carousel for improved accessibility
$('.section-stack .featured-collections-carousel').removeAttr('tabindex');

// Remove label element inside .form-control for accessibility adjustment
$('.form-control label').remove();

//Delete empty a tags with href="#"
$('a').each(function () {
    // Trim the inner content (text plus inner tags). 
    let content = $(this).html().trim();
    let hasOnlySVG = $(this).children().length === 1 && $(this).children().is('svg');
    
    if (
        $(this).attr('href') === '#' && 
        (content === '' || hasOnlySVG)
    ) {
        $(this).remove();
    }
});

// ESC press → Close search dialog & focus back on search button
$(document).on('keydown', function(e) {
  if (e.key === "Escape" || e.keyCode === 27) {
    var $dialog = $('header-search');
    var $button = $('a[href="/search"]');
    if ($dialog.is(':visible')) {
      $dialog.css('display', 'none').removeAttr('open');
      $button.focus();
    }
  }
});



// Converts plain PubMed/NCBI links in the page into clickable links with proper accessibility attributes
// Adds: target="_blank", rel="noopener noreferrer", and aria-label
$(document).ready(function () {
  const pubmedRegex = /https?:\/\/(?:www\.)?(pubmed\.ncbi\.nlm\.nih\.gov|ncbi\.nlm\.nih\.gov\/pmc\/articles)\/[^\s<>()]+/g;

  $('body').contents().each(function recursive() {
    if (this.nodeType === 3) { // Text node
      const text = this.nodeValue;
      const matches = text.match(pubmedRegex);
      if (matches) {
        const html = text.replace(pubmedRegex, function (url) {
          return `<a href="${url}" target="_blank" rel="noopener noreferrer" aria-label="PubMed National Center for Biotechnology Information, opens in new tab">${url}</a>`;
        });
        const span = $('<span>').html(html);
        $(this).replaceWith(span);
      }
    } else if (this.nodeType === 1 && !['SCRIPT', 'STYLE'].includes(this.nodeName)) {
      $(this).contents().each(recursive); // Recurse into child nodes
    }
  });
});

// Closes the currently expanded FAQ accordion when the Escape key is pressed
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    const openAccordion = document.querySelector('.faq details[open]');
    if (openAccordion) {
      openAccordion.removeAttribute('open');
      openAccordion.setAttribute('aria-expanded', 'false');
      openAccordion.querySelector('summary')?.focus(); // Optional: return focus to summary
    }
  }
});

// Custom dropdown toggle with Escape key and outside click close functionality
$(document).ready(function () {
  const $selector = $('.product-selector-select');
  const $options = $('.product-selector-options');

  function openDropdown() {
    $options.addClass('open');
    $selector.attr('aria-expanded', 'true');
  }

  function closeDropdown() {
    $options.removeClass('open');
    $selector.attr('aria-expanded', 'false');
  }

  // Toggle dropdown on click
  $selector.on('click', function (e) {
    e.stopPropagation();
    const isOpen = $selector.attr('aria-expanded') === 'true';
    isOpen ? closeDropdown() : openDropdown();
  });

  // Close dropdown when clicking outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.product-selector-options, .product-selector-select').length) {
      closeDropdown();
    }
  });

  // Close dropdown on Escape key press
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $options.hasClass('open')) {
      closeDropdown();
    }
  });
});

// Set aria-hidden="true" on all SVG icons inside .tabs to improve accessibility for screen readers
$('.tabs section ul li svg').attr('aria-hidden', 'true');

$(document).ready(function () {
  setTimeout(() => {
      $('.tab-text.ingredients a.facts_btn').attr({
    'aria-haspopup': 'true',
    'role': 'button'
  });
  }, 500);
});

// // Automatically focus on mobile menu heading when it becomes visible (accessibility enhancement)
$(document).ready(function () {
  const targetNode = document.querySelector('.mobile-navigation');

  // Watch for 'active_menu' class being added to .mobile-navigation
  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.attributeName === 'class') {
        const isActive = $(targetNode).hasClass('active_menu');

        if (isActive) {
          // Ensure menu is visible before applying focus (accessibility support)
          setTimeout(function () {
            // Move focus to the first heading inside the mobile menu
            $('.mobile-navigation h3[tabindex="-1"]').first().focus();
          }, 100); // Small delay for transition/DOM render
        }
      }
    }
  });

  // Start observing for class changes
  observer.observe(targetNode, {
    attributes: true,
    attributeFilter: ['class']
  });
});


// Add dynamic aria-label to "Read more" links on blogpages
$(document).ready(function () {
  $('.blog-post-card').each(function () {
    var $card = $(this);
    var title = $card.find('.blog-post-card__title').text().trim();
    var $readMore = $card.find('.blog-post-card__read-more');

    if (title && $readMore.length) {
      $readMore.attr('aria-label', 'Read more about ' + title);
    }
  });
});

// Add 'target="_blank"' and append 'open in new tab' to aria-label for social media share links on blogs
$('.article__footer a[aria-label], .social-media a[aria-label]').each(function () {
  var $link = $(this);
  var currentLabel = $link.attr('aria-label') || '';

  // Check if label already includes the sentence (case-insensitive)
  if (!/this link will open in a new tab\.?$/i.test(currentLabel.trim())) {
    $link.attr('aria-label', currentLabel.trim() + ' This link will open in a new tab.');
  }

  // Ensure link opens in new tab
  $link.attr('target', '_blank');
});


// Swap position of <picture> and .prose in .image-with-text--reverse sections
$(document).ready(function() {
  $('.image-with-text--reverse').each(function() {
    const $picture = $(this).find('picture');
    const $text = $(this).find('.prose');

    // Move .prose above <picture>
    if ($picture.length && $text.length) {
      $picture.insertAfter($text);
    }
  });
});

// Manage focus when nutrition facts popup opens and closes
$(document).ready(function () {
  var $popup = $('.image-popup');
  var $img = $popup.find('img');
  var $openBtn = $('.facts_btn');
  var $closeBtn = $popup.find('[aria-label="close"]');

  // Open popup
  $openBtn.on('click', function () {
    $popup.css('display', 'flex');
    setTimeout(function () {
      $img.focus(); // Move focus to image
    }, 100); // Delay for DOM update
  });

  // Close popup
  $closeBtn.on('click', function () {
    $popup.css('display', 'none');
    $openBtn.focus(); // Return focus to button
  });

  // Make image focusable (required for focus())
  $img.attr('tabindex', '-1');
});


// for email warning
$('a[href="mailto:hello@bobateaprotein.com"]').each(function () {
  const $link = $(this);

  // Add target="_blank" if not already present
  if (!$link.attr('target')) {
    $link.attr('target', '_blank');
  }

  // Add aria-label if not already present
  if (!$link.attr('aria-label')) {
    $link.attr('aria-label', 'Email hello@bobateaprotein.com. This link will open in new window');
  }

  // Remove title attribute
  $link.removeAttr('title');
});

// Add target and aria-label to UPS, USPS, and FedEx links if missing
$(document).ready(function () {
  const links = [
    {
      href: 'https://www.ups.com/us/en/support/file-a-claim.page',
      label: 'UPS'
    },
    {
      href: 'https://www.usps.com/help/contact-us.htm',
      label: 'USPS'
    },
    {
      href: 'https://www.fedex.com/en-us/customer-support/faqs/receiving/fedex-says-delivered-but-no-package.html',
      label: 'FedEx'
    }
  ];

  // Add target and aria-label to UPS, USPS, and FedEx links if missing
  links.forEach(function (item) {
    $('a[href="' + item.href + '"]').each(function () {
      const $link = $(this);

      if (!$link.attr('target')) {
        $link.attr('target', '_blank');
      }

      if (!$link.attr('aria-label')) {
        $link.attr('aria-label', 'Visit ' + item.label + '. This link will open in new tab');
      }
    });
  });
});

// Add target="_blank" and descriptive aria-labels to key external links for accessibility and new tab behavior
$(document).ready(function () {
  const links = [
    {
      href: 'https://www.shopify.com/legal/privacy',
      label: 'Shopify privacy policy'
    },
    {
      href: 'https://www.google.com/intl/en/policies/privacy/',
      label: 'Google privacy policy'
    },
    {
      href: 'https://tools.google.com/dlpage/gaoptout',
      label: 'Google Analytics opt-out page'
    },
    {
      href: 'http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work',
      label: 'the Network Advertising Initiative educational page'
    },
    {
      href: 'https://www.facebook.com/settings/?tab=ads',
      label: 'Facebook ad settings'
    },
    {
      href: 'https://www.google.com/settings/ads/anonymous',
      label: 'Google ad settings'
    },
    {
      href: 'https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads',
      label: 'Bing personalized ad policy'
    },
    {
      href: 'http://www.allaboutcookies.org',
      label: 'allaboutcookies.org'
    }
  ];

  // Loop through each defined link
  links.forEach(function (item) {
    $('a[href="' + item.href + '"]').each(function () {
      const $link = $(this);

      // Add target="_blank" if not already present
      if (!$link.attr('target')) {
        $link.attr('target', '_blank');
      }

      // Add aria-label if not already present
      if (!$link.attr('aria-label')) {
        $link.attr('aria-label', 'Visit ' + item.label + '. This link will open in new window');
      }
    });
  });
});

// changing price label
$('sale-price.h6.text-subdued').each(function () {
  const $span = $(this).find('span.sr-only');
  if ($span.text().trim() === 'Sale price') {
    $span.text('Regular price');
  }
});

// Improve link accessibility: remove title, add aria-label to all key links
// External links also get target="_blank" and "This link will open in new tab"
$(document).ready(function () {
  const links = [
    {
      href: 'https://www.bobateaprotein.com/pages/truly-grass-fed-verified%E2%84%A2',
      label: 'Visit the Truly Grass-Fed Verified page'
    },
    {
      href: 'https://bobateaprotein.com/pages/third-party-testing-results',
      label: 'View our Third-Party Testing Results'
    },
    {
      href: 'https://bobateaprotein.com/pages/our-story',
      label: 'Read our story'
    },
    {
      href: 'http://affirm.com/lenders',
      label: 'Visit affirm.com lenders page'
    },
    {
      href: 'https://www.affirm.com/licenses',
      label: 'Visit Affirm licenses page'
    },
    {
      href: 'https://bobateaprotein.com/policies/shipping-policy',
      label: 'Read our Shipping Policy'
    }
  ];

  links.forEach(function (item) {
    $('a[href="' + item.href + '"]').each(function () {
      const $link = $(this);

      // Remove title
      $link.removeAttr('title');

      // Check if link is external (not bobateaprotein.com)
      const isExternal = !item.href.includes('bobateaprotein.com');

      // Add aria-label if missing
      if (!$link.attr('aria-label')) {
        const fullLabel = isExternal ? item.label + '. This link will open in new window' : item.label;
        $link.attr('aria-label', fullLabel);
      }

      // Add target="_blank" only for external links
      if (isExternal && !$link.attr('target')) {
        $link.attr('target', '_blank');
      }
    });
  });
});


// When the hidden Close button is clicked, move focus to the first visible link inside .header__primary-nav for accessibility
$(document).ready(function () {
  // When the hidden close button is clicked
  $('.toggleBtn.sr-only').on('click', function () {
    // Find the closest .header__primary-nav and focus on the first <a> inside it
    $('.header__primary-nav').find('a:visible:first').focus();
  });
});

// Update aria-current and aria-selected dynamically on tab click for proper accessibility
$(document).ready(function () {
  // When any tab is clicked
  $('[role="tab"]').on('click', function () {
    // Remove aria-current and aria-selected from all tabs
    $('[role="tab"]').attr('aria-current', 'false').attr('aria-selected', 'false');

    // Set aria-current and aria-selected on the clicked tab
    $(this).attr('aria-current', 'true').attr('aria-selected', 'true');
  });
});

// If product is on sale (compare-at-price is visible), adds "Sale price" label
$(document).ready(function () {
  $('price-list').each(function () {
    const $priceList = $(this);
    const $salePrice = $priceList.find('sale-price');
    const $compareAt = $priceList.find('compare-at-price');

    if ($salePrice.length) {
      // Case 1: Only one price (compare-at is hidden)
      if ($compareAt.length && $compareAt.is('[hidden]')) {
        if ($salePrice.find('.sr-only').length === 0) {
          $salePrice.prepend('<span class="sr-only">Regular price</span>');
        }
      }

      // Case 2: Product on sale (compare-at is visible)
      if ($compareAt.length && !$compareAt.is('[hidden]')) {
        if ($salePrice.find('.sr-only').length === 0) {
          $salePrice.prepend('<span class="sr-only">Sale price</span>');
        }
      }
    }
  });
});
